export const approvalCountToUseAsyncRequest = 10;
export const denyCountToUseAsyncRequest = 10;
